import { ApiError } from '@/api/http';

/** Maps an unknown thrown value (typically from React Query) to an i18n error key. */
export function errorMessageKey(err: unknown): string {
  if (err instanceof ApiError) return `errors.${err.kind}`;
  return 'errors.unknown';
}
